import '@nuskin/ns-util';
import '@nuskin/ns-shop';
import angular from 'angular';
import 'angular-sanitize';
import 'angular-resource';

export var utilModule = angular.module('nsUtil', ['ngSanitize']);
export var shopModule = angular.module('nsShop', ['ngSanitize', 'ngResource', 'nsUtil']);
export var accountModule = angular.module('nsAccount', ['ngResource', 'nsUtil']);
